import { Button } from "antd";
import { shortenValue, useGlobalMerchant } from "utils/helper";

const ECSShippingComponent = ({
    itemList,
    grandTotal,
    onCheckout,
    onBtnLoader,
}: any) => {
    const { globalMerchantCurrency } = useGlobalMerchant();
    return (
        <div className="billingSummary">
            <div className="bSumHeader">
                <p className="sMdText fontSemiBold textCapitalize">Order Summary</p>
            </div>
            <div className="bSumBody">
                {itemList.map((items: any) => (
                    <div key={items.product.product_id} className='dFlex alignCenter bSumProductList justifyBetween'>
                        <span className="sSmText">
                            {items.product.product_name}
                        </span>
                        <span className="sMdText">
                            {shortenValue(items.qty * items.product.price)} {globalMerchantCurrency}
                        </span>
                    </div>
                ))}
                <div className='dFlex justifyBetween bSumTotal alignCenter'>
                    <p className="sMdText fontNormal">Total Amount</p>
                    <p className="sLgText">{shortenValue(grandTotal)} {globalMerchantCurrency}</p>
                </div>
                <p className="sXSmText">
                    When placing an order, we ask for your email and phone number (both
                    optional) as well as your address (required for delivery). This
                    information is used solely to process your order.
                </p>
            </div>
            <div className="bSumFooter">
                <Button
                    className="sBtn wFull"
                    type="primary"
                    onClick={() => onCheckout()}
                    disabled={grandTotal === 0}
                >
                    {onBtnLoader ? "Loading..." : "Proceed To Checkout"}<span></span>
                </Button>
            </div>
        </div>
    );
};

export default ECSShippingComponent;
